import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { AzureFileStorageLinkedService } from 'app/model/linkedservice/azure-file-storage.linkedservice';

import { IAttribute, IViolation, stringIsNullOrEmpty } from 'shell-models-lib';
import { CopyActivity } from '../../copy.activity';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { format } from 'app/shared/utils/string.util';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';
import { StoreReadSettings } from './store-read-settings';

@Metamodel.model({
    name: 'AzureFileStorageReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureFileStorageLinkedService)
    }
})

export class AzureFileStorageStoreReadSettings extends BlobTypeStoreReadSettings {
    public static readonly PREFIX: IAttribute;
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.PREFIX,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        templatable: true,
        association: 'PREFIX',
        display: stringResources.Prefix,
        constraint: {
            validator: AzureFileStorageStoreReadSettings.validateIRForBlobPrefixAsync
        }
    })
    public prefix?: string;

    private static async validateIRForBlobPrefixAsync(storeSettings: AzureFileStorageStoreReadSettings): Promise<IViolation[] | undefined> {
        if (storeSettings.filePathMode === FilePathMode.PREFIX && storeSettings.owner?.owner) {
            if (stringIsNullOrEmpty(storeSettings.prefix) && stringIsNullOrEmpty(AzureFileStorageStoreReadSettings.PREFIX.templateValue(storeSettings))) {
                return [{
                    context: storeSettings.prefix,
                    message: () => format(stringResources.ValidationError_EmptyFilePathTemplate, stringResources.Prefix, stringResources.Prefix)
                }];
            }
            const copyActivity = storeSettings.owner.owner.named;
            if (copyActivity instanceof CopyActivity && copyActivity.sourceDataset && copyActivity.sinkDataset) {
                const sourceLs = copyActivity.sourceDataset.linkedService as AzureFileStorageLinkedService;
                if (sourceLs && sourceLs.authenticationMethod === AuthenticationType.Basic) {
                    return [{
                        context: storeSettings.prefix,
                        message: () => `${stringResources.Prefix} ${format(stringResources.DirectCopyOnlySuppported_ErrorTemplate,
                            stringResources.AzureFileStorageAuthType_Error)}`
                    }];
                }
            }
        }
        return undefined;
    }

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        super.recoverPropFromPrevOne(prevStoreSettings);
        this.updateModelValue('prefix', this, prevStoreSettings);
    }
}
